module.exports = __webpack_public_path__ + "img/3中度加.d7f33aa7.gif";